export const PLANNING_SOURCE_LABELS = {
  client: 'Planning client',
  icc: 'Planning ICC',
  lda_client: 'LDA client',
};

export const PLANNING_CLIENT_SOURCE_LABELS = {
  client: 'Planning de référence client',
  icc: 'Planning prévisionnel ICC',
  lda_client: 'LDA contractuelle client',
};

export const PLANNING_COMPETENCY_LABELS = {
  cfo: 'CFO',
  cfa: 'CFA',
  ssi: 'SSI',
  pv: 'PV',
  studies: 'Études',
  drawing: 'Dessin',
};

export const PLANNING_SCOPE_LABELS = {
  PROJECT: 'Général',
  LOT: 'Lot',
  LEVEL: 'Niveau',
  LOT_LEVEL: 'Lot / niveau',
  ZONE: 'Zone',
  TABLEAU: 'Tableau électrique',
  BAIE: 'Baie CFA',
  WORK: 'Ouvrage',
  WORK_LEVEL: 'Ouvrage / niveau',
  EQUIPMENT: 'Équipement / système',
};

export const PLANNING_FEASIBILITY_LABELS = {
  feasible: 'Réalisable',
  tight: 'Tendu',
  unfeasible: 'Irréalisable en l’état',
  incomplete: 'À qualifier',
  unknown: 'À qualifier',
};

export const PLANNING_FEASIBILITY_CLIENT_LABELS = {
  feasible: 'Planning réalisable',
  tight: 'Planning sous contrainte',
  unfeasible: 'Planning non réalisable en l’état',
  incomplete: 'Faisabilité à confirmer',
  unknown: 'Faisabilité à confirmer',
};

export const planningFeasibilityLabel = (status, fallback = 'À qualifier') =>
  PLANNING_FEASIBILITY_LABELS[String(status || '').toLowerCase()] || fallback;

export const planningFeasibilityClientLabel = (status, fallback = 'Faisabilité à confirmer') =>
  PLANNING_FEASIBILITY_CLIENT_LABELS[String(status || '').toLowerCase()] || fallback;

export const planningCompetencyLabel = (value, fallback = '—') =>
  PLANNING_COMPETENCY_LABELS[String(value || '').toLowerCase()] || value || fallback;

export const planningScopeLabel = (scopeType, scopeCode, levelCode) => {
  const code = scopeCode || levelCode;
  if (code) return code;
  return PLANNING_SCOPE_LABELS[String(scopeType || '').toUpperCase()] || 'Général';
};
